<mat-card class="mat-elevation-z8 container-card">

    <!-- Azioni Upload -->
    <app-upload-file-panel [isUploading]="isUploading" [pendingFile]="pendingFile" [selectedLang]="selectedLang" (fileSelectedEvent)="onFileSelected($event)" (langChange)="onLangSelected($event)" (deleteFile)="removeFile()" (uploadFile)="onUpload($event)"></app-upload-file-panel>

    <!-- Search bar -->
    <app-search-bar [filterFields]="filterFields" [filterMap]="filterMap" [filterLabels]="filterLabels" (filtersChanged)="onFilterChanged($event)">
    </app-search-bar>

    <!-- Tabella -->
    <app-shared-table [nameTable]="'keywordsNotExpand'" [dataSource]="dataSourceKeywordsNotExpand" [displayedColumns]="displayedColumns" [columnLabels]="columnLabels" [notAllowAdd]="true" [notAllowEdit]="true" (openModal)="openDialog($event)" [length]="totalItems" [pageSize]="pageSize" [pageIndex]="pageIndex"
        (pageChanged)="onPageChanged($event)" (sortChanged)="onSortChanged($event)" (downloadAction)="downloadFile($event)" [isLoading]="isLoading" [hasError]="hasError">
    </app-shared-table>

    <app-loading [showLoading]="isLoadingFullScreen"></app-loading>
</mat-card>